/*
 * Boutique of Pashtuns — "Complete the Look" recommendation cards: adds
 * a card's default/first-available variant to the cart via AJAX, with a
 * lightweight inline confirmation. No page navigation, no cart drawer/
 * modal opened.
 *
 * Reuses Dawn's own primitives rather than building a parallel cart
 * system:
 * - fetchConfig() and the routes.cart_add_url global (assets/global.js,
 *   the same ones assets/product-form.js uses for the main Add to Cart
 *   button).
 * - The `sections`/`sections_url` request pattern Dawn's own
 *   cart-notification.js uses to ask Shopify to re-render just the
 *   header's cart-icon-bubble section alongside the add, then swaps that
 *   fresh HTML into the live #cart-icon-bubble element the same way
 *   cart-notification.js does (getSectionInnerHTML) -- so the header
 *   cart count updates correctly without opening the cart drawer.
 * - PUB_SUB_EVENTS.cartUpdate, published on success so any other
 *   Dawn component already listening for cart changes elsewhere on the
 *   page stays in sync too.
 *
 * Event-delegated on document (one listener, not one per card), so it
 * keeps working after <product-recommendations> replaces its innerHTML
 * once the recommendations fetch completes.
 */
(function () {
  function getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
  }

  function updateCartIconBubble(sectionsHtml) {
    const html = sectionsHtml && sectionsHtml['cart-icon-bubble'];
    if (!html) return;
    const bubble = document.getElementById('cart-icon-bubble');
    const inner = getSectionInnerHTML(html, '.shopify-section');
    if (bubble && inner) bubble.innerHTML = inner;
  }

  function setButtonState(button, label, extraClass) {
    const labelEl = button.querySelector('.pashtuns-complete-look__add-label');
    if (labelEl) labelEl.textContent = label;
    else button.textContent = label;
    if (extraClass) button.classList.add(extraClass);
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.pashtuns-complete-look__add');
    if (!button || button.disabled || button.classList.contains('is-loading')) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const originalLabel = button.querySelector('.pashtuns-complete-look__add-label')?.textContent || button.textContent;

    button.disabled = true;
    button.classList.add('is-loading');
    setButtonState(button, 'Adding…');

    const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
    };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['Content-Type'] = 'application/json';

    config.body = JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: ['cart-icon-bubble'],
      sections_url: window.location.pathname,
    });

    const addUrl = typeof routes !== 'undefined' && routes.cart_add_url ? routes.cart_add_url : '/cart/add';

    fetch(`${addUrl}.js`, config)
      .then((response) => response.json())
      .then((response) => {
        button.classList.remove('is-loading');

        if (response.status) {
          setButtonState(button, 'Try again');
          window.setTimeout(() => {
            setButtonState(button, originalLabel);
            button.disabled = false;
          }, 1800);
          return;
        }

        updateCartIconBubble(response.sections);

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'pashtuns-complete-look',
            cartData: response,
            variantId: variantId,
          });
        }

        setButtonState(button, 'Added ✓', 'is-added');
        window.setTimeout(() => {
          button.classList.remove('is-added');
          setButtonState(button, originalLabel);
          button.disabled = false;
        }, 1800);
      })
      .catch(() => {
        button.classList.remove('is-loading');
        setButtonState(button, 'Try again');
        window.setTimeout(() => {
          setButtonState(button, originalLabel);
          button.disabled = false;
        }, 1800);
      });
  });
})();
